import { FC, ReactElement } from 'react';

import { HStack, Text } from '@bonusly/design-system';

type IconAndTextContentProps = {
	icon: ReactElement;
	label: string;
	isExpanded: boolean;
	/** Optional keyboard shortcut to display (e.g., "⌘K" or "Ctrl+K") */
	shortcut?: string;
};

export const IconAndTextContent: FC<IconAndTextContentProps> = ({ icon, label, isExpanded, shortcut }) => (
	<HStack justifyContent="space-between" alignItems="center" spacing={3} w="full">
		<HStack spacing={3} flex={1} minW={0}>
			{icon}
			<Text
				fontSize={100}
				fontWeight="medium"
				whiteSpace="nowrap"
				opacity={isExpanded ? 1 : 0}
				transition={isExpanded ? 'opacity 0.15s 0.075s linear' : 'opacity 0.15s cubic-bezier(.4, 0, .2, 1)'}
			>
				{label}
			</Text>
		</HStack>
		{shortcut && (
			<Text
				fontSize="xs"
				fontWeight="medium"
				color="text.softest"
				bg="secondary.bgAlpha"
				px={2}
				py={0.5}
				borderRadius="sm"
				opacity={0}
				_groupHover={{ opacity: isExpanded ? 1 : 0 }}
			>
				{shortcut}
			</Text>
		)}
	</HStack>
);
